import React from "react";

export default function StatusFilter({
  options = [],
  selected,
  onChange,
  label = "Filter",
  className = "",
}) {
  return (
    <div className={`flex items-center gap-3 w-full min-w-0 ${className}`}>
      {label && (
        <span className="text-xs text-text_secondary shrink-0">{label}</span>
      )}

      {/* Single line; scrolls horizontally when options overflow */}
      <div
        className="flex items-center gap-2 flex-1 min-w-0 overflow-x-auto"
        style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" }}
      >
        {options.map((option) => (
          <button
            key={option}
            onClick={() => onChange(option)}
            className={[
              "shrink-0 whitespace-nowrap px-3 py-1 text-xs font-medium rounded-md transition-colors border",
              selected === option
                ? "bg-text_primary text-surface border-text_primary"
                : "bg-surface text-text_secondary border-border hover:bg-surface_alt hover:text-text_primary",
            ].join(" ")}
          >
            {option}
          </button>
        ))}
      </div>

      <style jsx>{`
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}
